import { Injectable } from '@angular/core';
import { jwtDecode } from "jwt-decode";
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { environment } from 'src/environments/environment';
import { RolesService } from './roles.service';

@Injectable({ providedIn: 'root' })
export class AuthentificationService {

    public userProfil: KeycloakProfile | null = null;
    public token: string | null = null;
    public roles: string | string[];

    /*
    La première implémentation utilisait un AsyncSubject pour l'utilisateur, mais ceci se prêtait mal
    à la possibilité de se déconnecter. A la place, on utilise donc un BehaviorSubject pour permettre
    à ces informations de 'vivre' avec l'application.
    */
    // private utilisateurSubject: AsyncSubject<LdapUser> = new AsyncSubject<LdapUser>();

    // private apiUrl: string;

    constructor(private readonly keycloak: KeycloakService) {
    }


    public login(): void {
        this.keycloak.login();
    }

    public logout(): void {
        this.keycloak.logout();
    }

    public getToken() {
        return this.keycloak.getToken();
    }

    public isUtilisateurAuthentifie(): boolean {
        return this.keycloak.isLoggedIn();
    }

    public loadUserProfile() {
        return this.keycloak.loadUserProfile();
    }

    public async getIelst() {
        this.token = await this.getToken();
        let ielst = '';
        const decodedToken: any = jwtDecode(this.token);
        if (decodedToken.i_elst !== undefined) {
            ielst = decodedToken.i_elst.toString();
        }
        return ielst;
    }

    public async getEmail() {
        this.userProfil = await this.loadUserProfile();
        return this.userProfil.email;
    }

    public getUserRoles() {
        return this.keycloak.getUserRoles(false, environment.clientId);
    }

    public isUserEnquete() {
        return this.keycloak.isUserInRole(RolesService.enquete);
    }

}
